<!--
 * @Description: 最低风险提示
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-10-21 14:46:45
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div class="comp-fund-protocol comp">
        <el-dialog
            class="prop"
            :visible.sync="centerDialogVisible"
            width="1000px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="closed"
        >
            <div slot="title" class="title-contain">
                <img
                    v-if="$cache.getCompanyInfoParam('10101007')"
                    :src="
                        $util.imgSrc({
                            fileCode: $cache.getCompanyInfoParam('10101007')
                        })
                    "
                    height="30"
                />
                <div class="title-bar">|</div>
                <div>销售适当性风险提示及声明</div>
            </div>
            <div class="protocol-con">
                <div class="risk-condition-contain">
                    <div class="img-flex">
                        <img src="@/assets/img/warn-tip.png" class="m-r-4" />
                        <div class="protocol-title">提示</div>
                    </div>
                    <div class="protocol-content" v-html="policyContent"></div>
                </div>
                <div class="row-bar"></div>
                <div class="risk-common-content3">
                    立即了解
                    <span v-on:click="toSdxText">《证券期货投资者适当性管理办法》</span>
                </div>
            </div>

            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" class="close-btn" v-on:click="closed">我知道了</el-button>
                <el-button type="primary" v-on:click="confirmCon">重新测评</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Router from "@/router";
import commonApi from "@/api/common";

export default {
    name: "LowRiskDialog",
    data() {
        return {
            centerDialogVisible: true,
            info: {},
            fundRisk: "",
            policyContent: "" // 从接口获取的政策文案
        };
    },
    mounted() {
        this.info = this.$cache.getUser();
    },
    methods: {
        // 获取政策文案
        async getPolicyContent() {
            if (this.info.risklevel === "0") {
                const userRiskLevel = this.$cache.getDict("100017", this.info.risklevel) || "";
                this.policyContent =
                    '您的风险测评结果是<span class="font-red">' +
                    this.escapeHtml(userRiskLevel) +
                    "</span>，不能购买任何产品。";
                return;
            }
            try {
                const res = await commonApi.qryProtocolContent({
                    policytype: "8"
                });
                let content = "";
                if (res.data && res.data.length > 0) {
                    // 取第一个政策内容的 content
                    content = res.data[0].content || "";
                }
                // 如果没有配置，使用默认文案
                if (!content) {
                    content =
                        // eslint-disable-next-line no-template-curly-in-string
                        "您的风险评测结果是${risklevel}，拟购买产品的风险等级为${fundRisk}，已超过您的风险承受能力，不可购买该产品。";
                }
                content = this.formatPolicyContent(content);
                this.policyContent = content;
            } catch (e) {
                console.error("获取政策文案失败", e);
                // 接口异常时，使用默认文案
                this.policyContent = this.formatPolicyContent(
                    // eslint-disable-next-line no-template-curly-in-string
                    "您的风险评测结果是${risklevel}，拟购买产品的风险等级为${fundRisk}，已超过您的风险承受能力，不可购买该产品。"
                );
            }
        },
        escapeHtml(value) {
            return String(value || "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        },
        // 字典未命中时可能返回对象，统一兜底为空避免展示 [object Object]。
        getDictText(dict, value) {
            const text = this.$cache.getDict(dict, value);
            return typeof text === "string" ? text : "";
        },
        formatPolicyContent(content) {
            const userRiskLevel = this.getDictText("100017", this.info.risklevel);
            const fundRiskLevel = this.getDictText("110143", this.fundRisk);
            const riskLevelHtml =
                '<span class="font-red">' + this.escapeHtml(userRiskLevel) + "</span>";
            const fundRiskHtml =
                '<span class="font-red">' + this.escapeHtml(fundRiskLevel) + "</span>";

            return this.escapeHtml(content)
                .replace(/\$\{risklevel\}/g, riskLevelHtml)
                .replace(/\$\{fundRisk\}/g, fundRiskHtml);
        },
        toSdxText() {
            const targetPath =
                window.location.protocol + "//" + window.location.host + "/#/sdxtext";
            window.open(targetPath, "_blank");
        },
        closed() {
            this.centerDialogVisible = false;
        },
        confirmCon() {
            this.centerDialogVisible = false;
            console.log(this, this.currentRouter);
            this.currentRouter.push({ name: "risk" });
        },
        openDialog(message) {
            this.fundRisk = message;
            this.centerDialogVisible = true;
            // 在设置 fundRisk 后获取政策内容
            this.getPolicyContent();
        }
    }
};
</script>
<style lang="scss">
.comp-fund-protocol {
    .title-contain {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        .title-bar {
            margin: 0 12px;
            color: #d9d9d9;
        }
    }
    .protocol-con {
        .risk-condition-contain {
            padding: 26px 0;
            .protocol-title {
                font-size: 20px;
                font-weight: bold;
                color: #333333;
            }
            .protocol-content {
                font-size: 16px;
                font-weight: normal;
                color: #333333;
                margin: 18px 0 0;
            }
        }

        .risk-common-content3 {
            margin: 14px 0 26px;
            font-size: 16px;
            font-weight: normal;
            color: #333333;
            span {
                color: #1890ff;
                cursor: pointer;
            }
        }
    }
    .dialog-footer {
        .close-btn {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: #e4e4e4;
            border: #e4e4e4;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #666666;
        }
    }
    .row-bar {
        width: 100%;
        height: 1px;
        background-color: #eeeeee;
    }
    .font-red {
        color: var(--color-primary);
    }
    .img-flex {
        display: flex;
        align-items: center;
    }
    .m-r-4 {
        margin-right: 4px;
    }
}
</style>
